module.exports = __webpack_public_path__ + "img/1.e43c5101.png";